import { createEmIcon } from '../designSystemIcons';

export const SignatureDateIcon = createEmIcon('calendar');
